import {apiSlice} from './apiSlice';

/**
 * Endpoints module Project (thực thể TỔNG, container cho các tool SEO).
 *
 * Chỉ CRUD thông tin chung của dự án (name + root_url). Dữ liệu/cấu hình của từng tool
 * (vd Site Crawler) do slice của tool đó phụ trách (crawlerApiSlice).
 */
export const projectApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getProjects: builder.query({
			query: (keyword = '') => ({
				url: 'projects',
				method: 'get',
				...(keyword ? {params: {keyword}} : {}),
			}),
			transformResponse: (body) => body?.data || [],
			providesTags: ['Project'],
		}),
		// Danh sách dự án + trạng thái tool rút gọn (crawl mới nhất + kết nối GSC) cho
		// Dashboard trang chủ. Nhẹ hơn nhiều so với gọi dashboard của từng dự án.
		getProjectsSummary: builder.query({
			query: () => ({url: 'projects/summary', method: 'get'}),
			transformResponse: (body) => body?.data || [],
			providesTags: ['Project'],
		}),
		getProject: builder.query({
			query: (id) => ({url: `projects/${id}`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: (result, error, id) => [{type: 'Project', id}],
		}),
		// Tổng quan dự án: gom số liệu từ các tool đã chạy (crawler/gsc/pagespeed/seo).
		getProjectDashboard: builder.query({
			query: (id) => ({url: `projects/${id}/dashboard`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: (result, error, id) => [{type: 'Project', id: `dashboard-${id}`}],
		}),
		// Báo cáo email định kỳ (#22): lịch gửi của dự án + allowed (gói có kênh email không).
		getReportSchedule: builder.query({
			query: (id) => ({url: `projects/${id}/report-schedule`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: (result, error, id) => [{type: 'Project', id: `report-${id}`}],
		}),
		updateReportSchedule: builder.mutation({
			query: ({id, schedule}) => ({url: `projects/${id}/report-schedule`, method: 'put', data: {schedule}}),
			transformResponse: (body) => body?.data || null,
			invalidatesTags: (result, error, {id}) => [{type: 'Project', id: `report-${id}`}],
		}),
		sendReportNow: builder.mutation({
			query: (id) => ({url: `projects/${id}/report-send`, method: 'post'}),
		}),
		// Chọn dự án hoạt động / chỉ đọc khi vượt trần gói (mục 5.3).
		setProjectActive: builder.mutation({
			query: ({id, active}) => ({url: `projects/${id}/active`, method: 'put', data: {active}}),
			transformResponse: (body) => body?.data || null,
			invalidatesTags: (result, error, {id}) => ['Project', {type: 'Project', id}],
		}),
		createProject: builder.mutation({
			query: (data) => ({url: 'projects', method: 'post', data}),
			transformResponse: (body) => body?.data || null,
			invalidatesTags: ['Project'],
		}),
		updateProject: builder.mutation({
			query: ({id, ...data}) => ({url: `projects/${id}`, method: 'put', data}),
			transformResponse: (body) => body?.data || null,
			invalidatesTags: (result, error, {id}) => ['Project', {type: 'Project', id}],
		}),
		deleteProject: builder.mutation({
			query: (id) => ({url: `projects/${id}`, method: 'delete'}),
			invalidatesTags: ['Project'],
		}),
	}),
});

export const {
	useGetProjectsQuery,
	useGetProjectsSummaryQuery,
	useGetProjectQuery,
	useGetProjectDashboardQuery,
	useGetReportScheduleQuery,
	useUpdateReportScheduleMutation,
	useSendReportNowMutation,
	useSetProjectActiveMutation,
	useCreateProjectMutation,
	useUpdateProjectMutation,
	useDeleteProjectMutation,
} = projectApiSlice;
